import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CalendarCheck, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";

export const CustomJewelry = () => {
  const [consultUrl, setConsultUrl] = useState("https://cal.com/dreamonds");

  useEffect(() => {
    api.get("/site/settings").then(({ data }) => {
      if (data?.consultation_url) setConsultUrl(data.consultation_url);
    }).catch(() => {});
  }, []);

  return (
    <section data-testid="custom-jewelry-section" className="bg-[#0A0A0A] text-white overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto text-center"
        >
          <p className="label-track text-[#C8A165] mb-4">Bespoke</p>
          <h2 className="font-heading font-bold tracking-tight text-3xl sm:text-4xl lg:text-6xl leading-[1.0]">
            Create Your <span className="italic text-[#E5C892]">Dream Piece.</span>
          </h2>
          <p className="mt-8 text-white/65 leading-relaxed max-w-xl mx-auto">
            Looking for something completely unique? Work directly with our jewelry experts to design
            a custom engagement ring or heirloom piece tailored to your vision. From first sketch to
            final polish, every step is yours.
          </p>

          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md mx-auto">
            {[
              { n: "01", t: "Consult" },
              { n: "02", t: "Design" },
              { n: "03", t: "Handcraft" },
            ].map((s) => (
              <div key={s.n}>
                <div className="text-[#C8A165] text-xs tracking-widest">{s.n}</div>
                <div className="font-heading text-lg text-white mt-1">{s.t}</div>
              </div>
            ))}
          </div>

          <a
              href="/book/consultation"
              data-testid="book-consultation-btn"
              className="mt-12 inline-flex items-center gap-3 bg-white text-[#0A0A0A] px-9 py-4 label-track transition-all duration-300 hover:bg-[#C8A165] hover:text-white group"
            >
            <CalendarCheck size={16} strokeWidth={1.5} />
            Book a Design Consultation
            <ArrowUpRight size={14} strokeWidth={1.6} className="transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
        </motion.div>
      </div>
    </section>
  );
};
